'use client';
import { Box, Container, Heading, SimpleGrid, Stack } from '@chakra-ui/react';
import { ReactNode } from 'react';

import CustomImage from '@/app/_components/custom-image/CustomImage';
import { getImageLink } from '@/services/link.service';
import { AboutMosaic } from '@/types/about/about.types';

import Styles from './Overview.module.scss';

type SimpleGridComponentProps = {
  className?: string;
  children: ReactNode;
  columns?: number[];
  alignItems?: string[];
  maxW?: string[];
  width?: string[];
  marginX?: string[];
};

type StackComponentProps = {
  className?: string;
  children: ReactNode;
  paddingY?: { [key: string]: string };
  paddingX?: { [key: string]: string };
  order?: { [key: string]: string };
  alignContent?: string;
};

const SimpleGridComponent = ({
  className,
  children,
  columns = [1, 1, 1, 2],
  alignItems = ['center'],
  width = ['100%'],
}: SimpleGridComponentProps) => {
  return (
    <SimpleGrid
      className={className}
      columns={columns}
      alignItems={alignItems}
      width={width}
    >
      {children}
    </SimpleGrid>
  );
};

const StackComponent = ({
  className,
  children,
  paddingY = { base: '20', md: '24', lg: '70px' },
  paddingX = { base: '8', md: '40', lg: '70px' },
  order = undefined,
  alignContent = 'center',
}: StackComponentProps) => {
  return (
    <Stack
      className={className}
      paddingY={paddingY}
      paddingX={paddingX}
      order={order}
      alignContent={alignContent}
    >
      {children}
    </Stack>
  );
};

const Overview = ({ data }: { data: AboutMosaic[] }) => {
  return (
    <Box className={Styles.overviewSectionWrapper}>
      <Container
        paddingTop={{ base: '0', md: '56px' }}
        paddingBottom={{ base: '0px', md: '56px' }}
        marginX={{ base: '0', md: 'auto' }}
        paddingX={{ base: '0', md: 4 }}
        maxW={'1280'}
        width={'100%'}
        gap={{ base: '0px', md: '24px' }}
        display={'flex'}
        flexDirection={'column'}
      >
        {data &&
          data?.length &&
          data.map((item, index) => {
            return (
              <SimpleGridComponent key={index}>
                <Box
                  className={Styles.overviewImgBlock}
                  order={
                    index % 2 === 0
                      ? { base: '1', lg: '2' }
                      : { base: '2', lg: '0' }
                  }
                >
                  <CustomImage
                    imageSrc={getImageLink(item?.image_id || '') ?? ''}
                    className={Styles.overviewImage}
                    alt={item?.image_alt ?? ''}
                    width={1328}
                    height={712}
                    imageKeys={{
                      desktopKey: 'image-1328-712',
                      mobileKey: 'image-430-305',
                    }}
                  />
                </Box>
                <StackComponent className={Styles.overviewDetails}>
                  <Box
                    className={Styles.headingElement}
                    order={index % 2 === 0 ? { base: '1', lg: '1' } : {}}
                  >
                    <Heading
                      as="h4"
                      className={Styles.titleMd}
                      marginBottom={{ base: 4, md: 4 }}
                    >
                      {item?.title}
                    </Heading>
                    <Box
                      className={Styles.titleText}
                      dangerouslySetInnerHTML={{
                        __html: item?.paragraph ?? '',
                      }}
                    ></Box>
                  </Box>
                </StackComponent>
              </SimpleGridComponent>
            );
          })}
      </Container>
    </Box>
  );
};

export default Overview;
